import type { MapContent } from '@mawkaa/types';
import { MapPin } from 'lucide-react';

interface MapBlockProps {
  content: MapContent;
  isEditing?: boolean;
}

export function MapBlock({ content, isEditing }: MapBlockProps) {
  const { address, lat, lng, zoom = 15, title } = content;

  // Generate Google Maps embed URL
  const getMapUrl = () => {
    if (lat && lng) {
      return `https://www.google.com/maps/embed/v1/view?key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8&center=${lat},${lng}&zoom=${zoom}`;
    }
    if (address) {
      return `https://www.google.com/maps/embed/v1/place?key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8&q=${encodeURIComponent(address)}`;
    }
    return null;
  };

  const mapUrl = getMapUrl();

  if (!mapUrl) {
    return (
      <section className="px-4 py-12">
        <div className="max-w-4xl mx-auto">
          {title && <h2 className="text-2xl font-bold text-center mb-6">{title}</h2>}
          <div className="aspect-video bg-gray-100 rounded-lg flex items-center justify-center">
            <div className="text-center text-muted-foreground">
              <MapPin className="w-12 h-12 mx-auto mb-2" />
              <p>Ajoutez une adresse ou des coordonnées</p>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="px-4 py-12">
      <div className="max-w-4xl mx-auto">
        {title && <h2 className="text-2xl font-bold text-center mb-6">{title}</h2>}
        <div className="aspect-video rounded-lg overflow-hidden">
          <iframe
            src={mapUrl}
            className="w-full h-full border-0"
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
        {address && (
          <p className="text-center mt-4 text-muted-foreground">
            <MapPin className="w-4 h-4 inline mr-1" />
            {address}
          </p>
        )}
      </div>
    </section>
  );
}
